/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchedulationCreateRequest } from '../../models/schedulation-create-request';
import { SchedulationResponse } from '../../models/schedulation-response';

export interface PostFeV1Schedulations$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
  
    /**
     * Schedulation creation data.
     */
    body?: SchedulationCreateRequest
}

export function postFeV1Schedulations$Plain(http: HttpClient, rootUrl: string, params?: PostFeV1Schedulations$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulationResponse>> {
  const rb = new RequestBuilder(rootUrl, postFeV1Schedulations$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchedulationResponse>;
    })
  );
}

postFeV1Schedulations$Plain.PATH = '/v1/schedulations';
